<template>
  <van-popup v-model="isShowCommentForm" position="bottom" :get-container="getContainer" :overlay="false" :duration="0.2" class="comment_form_box">
    <div class="comment_form_title">
      <span class="form_title">评论</span>
      <span class="comment_cancel" @click="hideCommentForm">取消</span>
    </div>
    <div>
      <van-field v-model.trim="commentMsg" rows="2" autosize type="textarea" maxlength="50" placeholder="请输入评论" show-word-limit />
    </div>
    <div class="comment_form_submit">
      <van-button type="danger" round size="small" class="comment_submit" @click="commentSubmit">发布</van-button>
    </div>
  </van-popup>
</template>
<script>
import { mapState } from "vuex";
import commApi from "@/api/apis/common.js";
export default {
  name: "SubmitComment",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number,
      default: 16,
    },
    id: {
      type: Number,
      default: 0,
    },
    parentId: {
      type: String,
      default: "0",
    },
    title: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  data() {
    return {
      /* 是否显示评论表单 */
      isShowCommentForm: false,
      /* 评论内容 */
      commentMsg: "",
      commentParentId: "0",
    };
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        this.isShowCommentForm = newValue;
      },
      deep: true,
    },
    type: {
      handler(newValue, oldValue) {
        this.contentType = newValue || 16;
      },
      deep: true,
    },
    id: {
      handler(newValue, oldValue) {
        this.contentId = newValue;
      },
      deep: true,
    },
    parentId: {
      handler(newValue, oldValue) {
        this.commentParentId = newValue;
      },
      deep: true,
    },
  },
  methods: {
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer() {
      return document.querySelector(".live_container");
    },
    /* 关闭评论表单 */
    hideCommentForm() {
      this.$emit("showCommentForm", false);
    },
    /* 提交评论 */
    commentSubmit() {
      var _this = this;
      if (_this.commentMsg.length > 0) {
        let params = {
          contentType: _this.contentType,
          contentId: _this.contentId,
          comment: _this.commentMsg,
          memberId: _this.userInfo.id,
          memberName: _this.userInfo.userName,
          deviceId: null,
          contentTitle: _this.title,
          contentKeyword: null,
          nodeId: null,
          contentCode: _this.userInfo.memberCode,
          nodeCode: _this.nodeCode,
          parentId: _this.commentParentId,
          type: 1, // 1普通评论 2对主持人发布的内容评论
        };

        commApi
          .addComment(params)
          .then((res) => {
            if (res.suc == 1) {
              _this.$emit("showCommentForm", false);
              _this.commentMsg = "";
              _this.$toast({
                message: "评论成功，待审核通过后方可展示！",
                position: "center",
              });
            } else {
              _this.$toast({
                message: res.message,
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      } else {
        _this.$toast({
          message: "请填写评论内容！",
          position: "center",
        });
      }
    },
  },
  created() {
    this.isShowCommentForm = this.show;
    this.contentType = this.type || 16;
    this.contentId = this.id;
    this.commentParentId = this.parentId;
  },
};
</script>
<style scoped lang="scss">
.comment_form_box {
  position: absolute;
  width: 100%;
  height: 172px;
  padding: 10px 15px;
  background: #f2f2f2;
  border-top: 1px solid #dcdcdc;
  overflow: hidden;
  .comment_form_title {
    position: relative;
    text-align: center;
    padding-bottom: 10px;
    font-size: 14px;
    .comment_cancel {
      position: absolute;
      right: 0;
      color: #b3b3b3;
    }
  }
  .comment_form_submit {
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: right;
    .comment_submit {
      height: 22px;
      border-radius: 5px;
    }
  }
}
</style>